import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

Alpine.data('relatedIssues', () => ({
	init() {
		this.initialiseCarousel();
	},
	initialiseCarousel() {
		new Swiper('.swiper', {
			modules: [Pagination],
			slidesPerView: 1,
			spaceBetween: 24,
			centeredSlides: true,
			loop: true,
			autoHeight: true,
			grabCursor: true,
			a11y: {
				enabled: true,
				prevSlideMessage: 'Previous related issue',
				nextSlideMessage: 'Next related issue',
				firstSlideMessage: 'First related issue',
				lastSlideMessage: 'Last related issue',
			},

			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},

			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 60,
				},
				1024: {
					slidesPerView: 2,
					spaceBetween: 140,
				},
			},
		});
	},
}));
